import {AxiosInstance} from "axios";
import DictionaryItem from "../model/dictionary/DictionaryItem";
import Task from "../model/task/Task";

/**
 * Api for activity template.
 */
export default class ActivityTemplateApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch activity templates.
	 * @returns {Promise<DictionaryItem[]>} Promise containing all activity templates.
	 */
	fetchActivityTemplates(): Promise<DictionaryItem[]> {
		const url = `/api/web/activity_templates`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(DictionaryItem.fromJson));
	}

	/**
	 * Fetch activity template tasks
	 * @param {string} activityTemplateId
	 * @returns {Promise<Task[]>}
	 */
	fetchActivityTemplateTasks(activityTemplateId: string): Promise<Task[]> {
		const url = `/api/web/activity_template/${activityTemplateId}/tasks`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(Task.fromJson));
	}

	/**
	 * Save activity template tasks in given order.
	 * @param activityTemplateId
	 * @param tasksIds
	 */
	setActivityTemplateTasks(activityTemplateId: string, tasksIds: string[]): Promise<any> {
		const url = `/api/web/activity_templates/${activityTemplateId}`;
		return this.axiosInstance.put(url, tasksIds)
	}

	/**
	 * Fetch activity templates.
	 * @returns {Promise<DictionaryItem[]>} Promise containing all activity templates.
	 */
	fetchJobActivityTemplates(): Promise<DictionaryItem[]> {
		const url = `/api/web/job_activity_templates`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(DictionaryItem.fromJson));
	}

	/**
	 * Fetch job activity template tasks
	 * @param {string} activityTemplateId
	 * @returns {Promise<Task[]>}
	 */
	fetchJobActivityTemplateTasks(activityTemplateId: string): Promise<Task[]> {
		const url = `/api/web/job_activity_templates/${activityTemplateId}/tasks`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(Task.fromJson));
	}


	/**
	 * Save job activity template tasks in given order.
	 * @param activityTemplateId
	 * @param tasksIds
	 */
	setJobActivityTemplateTasks(activityTemplateId: string, tasksIds: string[]): Promise<any> {
		const url = `/api/web/job_activity_templates/${activityTemplateId}`;
		return this.axiosInstance.put(url, tasksIds)
	}
}